// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mention[data-v-76a461bb]{display:contents;white-space:nowrap}`, "",{"version":3,"sources":["webpack://./src/components/MessagesList/MessagesGroup/Message/MessagePart/Mention.vue"],"names":[],"mappings":"AACA,0BACC,gBAAA,CACA,kBAAA","sourcesContent":["\n.mention {\n\tdisplay: contents;\n\twhite-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
